import React, { FC, memo } from 'react';

import { Switch as MSwitch, SwitchProps } from '@mui/material';

import useStyles from './styles.module';

type Props = SwitchProps & {
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
};

const Switch: FC<Props> = ({
  checked,
  onChange = undefined,
  disabled = false,
  className = '',
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <MSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={cx(classes.root, className)}
      sx={{ m: 1 }}
      disableRipple
      focusVisibleClassName=".Mui-focusVisible"
      {...props}
    />
  );
};

export default memo(Switch);
